import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Landing from './pages/Landing';
import BookingDetails from './pages/BookingDetails';
import DriverRegister from './pages/DriverRegister';
import DriverDashboard from './pages/DriverDashboard';
import CustomerDashboard from './pages/CustomerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import CompanyRegister from './pages/CompanyRegister';
import RatePage from './pages/RatePage';
import DriverPublicProfile from './pages/DriverPublicProfile';
import CompanyPublicProfile from './pages/CompanyPublicProfile';
import CustomerProfile from './pages/CustomerProfile';
import AGB from './pages/AGB';
import Datenschutz from './pages/Datenschutz';
import Impressum from './pages/Impressum';
import DriverAGB from './pages/DriverAGB';
import Contact from './pages/Contact';
import KontoLoeschen from './pages/KontoLoeschen';
import AuthCallback from './pages/AuthCallback';
import AdminDriverDetail from './pages/AdminDriverDetail';
import CookieConsent from './components/CookieConsent';
import DriverApp from './pwa/DriverApp';
import AirportTransferLanding from './pages/landing/AirportTransferLanding';
import RouteLanding from './pages/seo/RouteLanding';

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/booking" element={<BookingDetails />} />
      <Route path="/driver/register" element={<DriverRegister />} />
      <Route path="/driver/dashboard" element={<DriverDashboard />} />
      <Route path="/driver/public/:driverId" element={<DriverPublicProfile />} />
      <Route path="/my-transfers" element={<CustomerDashboard />} />
      <Route path="/profile" element={<CustomerProfile />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/driver/:driverId" element={<AdminDriverDetail />} />
      <Route path="/company/register" element={<CompanyRegister />} />
      <Route path="/company/public/:companyId" element={<CompanyPublicProfile />} />
      <Route path="/rate" element={<RatePage />} />
      <Route path="/agb" element={<AGB />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/konto-loeschen" element={<KontoLoeschen />} />
      <Route path="/delete-account" element={<KontoLoeschen />} />
      <Route path="/account-deletion" element={<KontoLoeschen />} />
      <Route path="/fahrer-agb" element={<DriverAGB />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/driver-app" element={<DriverApp />} />
      <Route path="/driver-app/*" element={<DriverApp />} />

      {/* SEO landing pages – German */}
      <Route path="/flughafentransfer" element={<AirportTransferLanding landingKey="flughafentransfer" />} />
      <Route path="/flughafentransfer/zuerich" element={<AirportTransferLanding landingKey="flughafentransfer-zuerich" />} />
      <Route path="/flughafentransfer/basel" element={<AirportTransferLanding landingKey="flughafentransfer-basel" />} />
      <Route path="/flughafentransfer/genf" element={<AirportTransferLanding landingKey="flughafentransfer-genf" />} />
      <Route path="/flughafentransfer/bern" element={<AirportTransferLanding landingKey="flughafentransfer-bern" />} />

      {/* SEO landing pages – English */}
      <Route path="/en/airport-transfer" element={<AirportTransferLanding landingKey="airport-transfer" />} />
      <Route path="/en/airport-transfer/zurich" element={<AirportTransferLanding landingKey="airport-transfer-zurich" />} />
      <Route path="/en/airport-transfer/basel" element={<AirportTransferLanding landingKey="airport-transfer-basel" />} />

      {/* SEO landing pages – Egypt DE */}
      <Route path="/flughafentransfer-hurghada" element={<AirportTransferLanding landingKey="flughafentransfer-hurghada" />} />
      <Route path="/flughafentransfer-hurghada-preise" element={<AirportTransferLanding landingKey="flughafentransfer-hurghada-preise" />} />
      <Route path="/flughafentransfer-marsa-alam" element={<AirportTransferLanding landingKey="flughafentransfer-marsa-alam" />} />
      <Route path="/flughafentransfer-luxor" element={<AirportTransferLanding landingKey="flughafentransfer-luxor" />} />
      <Route path="/flughafentransfer-kairo" element={<AirportTransferLanding landingKey="flughafentransfer-kairo" />} />

      {/* SEO landing pages – Egypt EN */}
      <Route path="/en/hurghada-airport-transfer" element={<AirportTransferLanding landingKey="hurghada-airport-transfer" />} />
      <Route path="/en/marsa-alam-airport-transfer" element={<AirportTransferLanding landingKey="marsa-alam-airport-transfer" />} />
      <Route path="/en/luxor-airport-transfer" element={<AirportTransferLanding landingKey="luxor-airport-transfer" />} />
      <Route path="/en/cairo-airport-transfer" element={<AirportTransferLanding landingKey="cairo-airport-transfer" />} />

      {/* SEO landing pages – Batch 1 (short, high-ROI slugs) */}
      <Route path="/private" element={<AirportTransferLanding landingKey="private" />} />
      <Route path="/sharm" element={<AirportTransferLanding landingKey="sharm" />} />
      <Route path="/cairo" element={<AirportTransferLanding landingKey="cairo" />} />
      <Route path="/hurghada" element={<AirportTransferLanding landingKey="hurghada" />} />
      <Route path="/safaga" element={<AirportTransferLanding landingKey="safaga" />} />

      {/* NEW SEO Route landings – dynamic params, placed AFTER all exact routes above. No catch-all is registered in this Router. */}
      <Route path="/transfer/:from/:to" element={<RouteLanding lang="de" />} />
      <Route path="/en/transfer/:from/:to" element={<RouteLanding lang="en" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <CookieConsent />
    </BrowserRouter>
  );
}
